'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _immutable = require('immutable');

require('ngreact');

require('angular-drag-and-drop-lists');

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _events = require('ifeis-isomorphic/lib/redux/actions/events');

var _feiseanna = require('ifeis-isomorphic/lib/redux/actions/feiseanna');

var _editor = require('../../../../../syllabus/editor');

var _editor2 = _interopRequireDefault(_editor);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _chart = require('./chart');

var _table = require('./table');

var _filterDrawer = require('./filterDrawer.html');

var _filterDrawer2 = _interopRequireDefault(_filterDrawer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Filter drawer settings
var MERGE_SPLIT_COLUMN_ORDER = ['SelectForMerge', // checkbox to select event for merge
'Level', 'Event', 'Age'];
var ORDER_BY_MERGE_SPLIT = 'mergeSplit';

var FeisSyllabusController = function () {
  function FeisSyllabusController($ngRedux, $scope, $mdSidenav, feis, fEventEditor, fRouterHistoryService, fCSVReportsService) {
    var _this = this;

    _classCallCheck(this, FeisSyllabusController);

    this._ = {
      $ngRedux: $ngRedux,
      $mdSidenav: $mdSidenav,
      fEventEditor: fEventEditor,
      fRouterHistoryService: fRouterHistoryService,
      fCSVReportsService: fCSVReportsService
    };

    // Filter drawer settings
    this.mergeSplitViewEnabled = false;
    this.showStatisticsColumns = false;

    this.headers = _table.INITIAL_COLUMN_HEADERS // use INITIAL_COLUMN_HEADERS to avoid merge/split column order (when enabled)
    ;

    // Make checkbox column for merges visible if mergeSplitViewEnabled
    // ASSUMES first column in INITIAL_COLUMN_HEADERS is the 'SelectForMerge' one
    this.headers = this.headers.update(0, function (col) {
      return _extends({}, col, { visible: _this.mergeSplitViewEnabled });
    });

    this.feis = (0, _immutable.fromJS)(feis);

    // Default to showing charts.
    this.showCharts = true;

    // For the non-chart view, default filters and sorts.
    this.orderBy = _table.INITIAL_ORDER_BY;
    this.filter = '';

    this.eventsToMerge = (0, _immutable.List)();

    // Set the initial state and listen for subsequent state changes.
    $ngRedux.connect((0, _mapStateToController2.default)(this.feis))(this);
    $ngRedux.dispatch((0, _events.getEvents)(this.feis.get('id'), true));
    $ngRedux.dispatch((0, _feiseanna.getEventLevels)(this.feis.get('id')));
    $ngRedux.dispatch((0, _feiseanna.getEventTypes)(this.feis.get('id')));

    // Start by displaying the first tab, of course.
    this.currentTypeIdx = 0;

    // Always remove '.no-scrollable' class when sidebar closes
    this._.$mdSidenav('right', true).then(function (instance) {
      instance.onClose(function () {
        document.body.classList.remove('no-scrollable');
      });
    });
  }

  _createClass(FeisSyllabusController, [{
    key: 'isLoading',
    value: function isLoading() {
      return this.events.get('loading');
    }
  }, {
    key: 'back',
    value: function back() {
      this._.fRouterHistoryService.back();
    }
  }, {
    key: 'order',
    value: function order(newOrderBy) {
      newOrderBy = (0, _immutable.fromJS)(newOrderBy);

      // remove mergeSplit orderBy since mergeSplit cannot be combined with a custom sort
      this.orderBy = newOrderBy.filter(function (orderBy) {
        return orderBy.get('name') !== ORDER_BY_MERGE_SPLIT;
      });

      // make sure columns that user is sorting by are visible
      var orderByColumns = this.orderBy.map(function (column) {
        return column.get('name');
      });
      this.headers = this.headers.map(function (column) {
        if (orderByColumns.includes(column.name)) {
          return _extends({}, column, { visible: true });
        } else {
          return column;
        }
      });
    }
  }, {
    key: 'currentType',
    value: function currentType() {
      return this.types.get(this.currentTypeIdx);
    }
  }, {
    key: 'getCharts',
    value: function getCharts() {
      return this.currentType().get('charts');
    }
  }, {
    key: 'edit',
    value: function edit(event) {
      if (!event) {
        return;
      }

      return this._.fEventEditor(null, this.feis.get('id'), event.get('id'), event);
    }
  }, {
    key: 'add',
    value: function add() {
      var tpl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();

      tpl = tpl.set('type', this.currentType().get('value'));

      return this.edit((0, _immutable.fromJS)(tpl));
    }
  }, {
    key: 'addToChart',
    value: function addToChart(chart) {
      return this.add((0, _immutable.Map)({ level: chart.get('level') }));
    }
  }, {
    key: 'showEvent',
    value: function showEvent(event) {
      if (event.get('$placeholder')) {
        return this.add(event.get('$placeholder').toJS());
      }

      return this.edit(event);
    }
  }, {
    key: 'toggleLeftNav',
    value: function toggleLeftNav() {
      this._.$mdSidenav('left').toggle();
    }
  }, {
    key: 'onToggleSideMenu',
    value: function onToggleSideMenu() {
      if (this._.$mdSidenav('right').isOpen()) {
        document.body.classList.remove('no-scrollable');
      } else {
        document.body.classList.add('no-scrollable');
      }
      this._.$mdSidenav('right').toggle();
    }
  }, {
    key: 'onToggleMergeSplitView',
    value: function onToggleMergeSplitView() {
      var mergeSplitViewEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (mergeSplitViewEnabled !== null) {
        this.mergeSplitViewEnabled = mergeSplitViewEnabled;
      } else {
        this.mergeSplitViewEnabled = !this.mergeSplitViewEnabled;
      }
      if (this.mergeSplitViewEnabled) {
        this.headers = this.headers.sortBy(function (col) {
          var idx = MERGE_SPLIT_COLUMN_ORDER.indexOf(col.name);
          if (idx !== -1) {
            // column has specified order - adjust its position
            return idx;
          } else {
            return Infinity; // move column to be after columns with specified order
          }
        });

        // Make checkbox column for merges visible
        // ASSUMES first value in MERGE_SPLIT_COLUMN_ORDER is 'SelectForMerge'
        this.headers = this.headers.update(0, function (col) {
          return _extends({}, col, { visible: true });
        });

        this.previousOrderBy = this.orderBy;
        this.orderBy = (0, _immutable.fromJS)([{ name: ORDER_BY_MERGE_SPLIT }]);
      } else {
        var initialSortOrder = _table.INITIAL_COLUMN_HEADERS.map(function (col) {
          return col.name;
        });
        // avoids overwriting visibility of columns (vs just setting headers to initial ones)
        this.headers = this.headers.sortBy(function (col) {
          return initialSortOrder.indexOf(col.name);
        });

        // Hide checkbox column for merges
        // ASSUMES first column in INITIAL_COLUMN_HEADERS is the 'SelectForMerge' one
        this.headers = this.headers.update(0, function (col) {
          return _extends({}, col, { visible: false });
        });

        this.orderBy = this.previousOrderBy;
      }
    }
  }, {
    key: 'toggleEventToMerge',
    value: function toggleEventToMerge(eventId) {
      if (this.eventsToMerge.includes(eventId)) {
        return this.eventsToMerge = this.eventsToMerge.filter(function (id) {
          return id !== eventId;
        });
      }

      // keeps 2 selected events
      if (this.eventsToMerge.size >= 2) {
        this.eventsToMerge = this.eventsToMerge.shift();
      }
      return this.eventsToMerge = this.eventsToMerge.push(eventId);
    }
  }, {
    key: 'downloadSyllabus',
    value: function downloadSyllabus() {
      var csv = [];

      var validHeaders = this.headers.filter(function (col) {
        return col.visible && col.csvMapping;
      });

      var csvHeader = validHeaders.map(function (col) {
        return col.name;
      });

      csv.push(csvHeader);

      this.storedResult.forEach(function (event) {
        var values = validHeaders.map(function (column) {
          if (!column.csvFunction) {
            return event[column.csvMapping];
          }
          return column.csvMapping((0, _immutable.fromJS)(event));
        });
        csv.push(values);
      });

      this._.fCSVReportsService.prepareCSV(csv, 'Syllabus_' + this.feis.get('name') + '.csv');
    }
  }, {
    key: 'filteredEvents',
    value: function filteredEvents() {
      var _this2 = this;

      var events = this.events,
          filter = this.filter,
          orderBy = this.orderBy;

      var compareByAge = function compareByAge(a, b, sortAscending) {
        if (a && b) {
          return sortAscending ? parseInt(a, 10) - parseInt(b, 10) : parseInt(b, 10) - parseInt(a, 10);
        } else if (!a && !b) {
          return 0;
        } else if (!a) {
          return sortAscending ? 1 : -1;
        } else {
          return sortAscending ? -1 : 1;
        }
      };

      // convert to map to speed up lookups in inner sort loop
      var IS_NUMBER_COLUMN = _table.INITIAL_COLUMN_HEADERS.filter(function (col) {
        return col.number;
      }).reduce(function (acc, col) {
        acc[col.name] = true;
        return acc;
      }, {});

      var compareColumn = function compareColumn(a, b, columnName, sortAscending) {
        var aColumn = (0, _table.getEventProperty)(a, columnName);
        var bColumn = (0, _table.getEventProperty)(b, columnName);

        var order;
        if (IS_NUMBER_COLUMN[columnName]) {
          // number sort, undefined and null values will cause event to stay in its original place
          order = parseInt(aColumn, 10) - parseInt(bColumn, 10);
        } else {
          // default string values
          aColumn = aColumn || '';
          bColumn = bColumn || '';
          order = aColumn.localeCompare(bColumn); // alphabetical sort
        }

        return sortAscending ? order : -1 * order;
      };

      // sort by sortOrder
      // if item not found, sort alphabetically after specified sortOrder events
      var compareBySpecifiedOrder = function compareBySpecifiedOrder() {
        var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var sortOrder = arguments[2];
        var sortAscending = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

        var aIdx = sortOrder.get(a) || Infinity;
        var bIdx = sortOrder.get(b) || Infinity;

        // sort alphabetically if neither item is in the sort order list
        if (aIdx === Infinity && bIdx === Infinity) {
          return sortAscending ? a.localeCompare(b) : b.localeCompare(a);
        }

        return sortAscending ? aIdx - bIdx : bIdx - aIdx;
      };

      // use map to speed up index lookups in inner sort loop
      var CATEGORY_ORDER = (0, _immutable.fromJS)(['G', 'C', 'F', 'S'].reduce(function (acc, category, idx) {
        acc[category] = idx + 1;
        return acc;
      }, {}));

      // merge/split sort - by level, event type, age
      var compareMergeSplit = function compareMergeSplit(a, b) {
        var order;

        // sort by event category
        order = compareBySpecifiedOrder(a.get('type'), b.get('type'), CATEGORY_ORDER);
        if (order !== 0) {
          return order;
        }

        // sort by level ascending
        order = compareBySpecifiedOrder(a.get('level'), b.get('level'), _this2.eventLevels);
        if (order !== 0) {
          return order;
        }

        // sort by event type
        order = compareBySpecifiedOrder(a.get('event'), b.get('event'), _this2.eventTypes);
        if (order !== 0) {
          return order;
        }

        // sort numerically by maximum age ascending
        order = compareByAge(a.get('age_max'), b.get('age_max'), true);
        // if age_max is equal, compare by age_min
        if (order === 0) order = compareByAge(a.get('age_min'), b.get('age_min'), true);

        return order;
      };

      var filterableFields = ['name', 'level', 'event', 'age'];

      var result = filter !== ''
      // FIXME(joshdmiller): debounce
      ? events.filter(function (event) {
        return event.filter(function (v, k) {
          return filterableFields.includes(k);
        }).toList().find(function (prop) {
          return prop.toLowerCase().indexOf(filter.toLowerCase()) > -1;
        });
      }) : events;

      var storedResult = result.sort(function (a, b) {
        var order;

        orderBy.forEach(function (orderByColumn) {
          var columnName = orderByColumn.get('name');
          var sortAscending = orderByColumn.get('asc');

          switch (columnName) {
            case 'mergeSplit':
              order = compareMergeSplit(a, b);

              // break out of forEach if we're doing mergeSplit sort
              // in practice, when mergeSplit is enabled, it will be the only item in orderBy
              return false;
            case 'Level':
              order = compareBySpecifiedOrder(a.get('level'), b.get('level'), _this2.eventLevels, sortAscending);
              break;
            case 'Event':
              order = compareBySpecifiedOrder(a.get('event'), b.get('event'), _this2.eventTypes, sortAscending);
              break;
            case 'Type':
              order = compareBySpecifiedOrder(a.get('type'), b.get('type'), CATEGORY_ORDER, sortAscending);
              break;
            case 'Age':
              order = compareByAge(a.get('age_max'), b.get('age_max'), sortAscending);
              // if age_max is equal, compare by age_min
              if (order === 0) order = compareByAge(a.get('age_min'), b.get('age_min'), sortAscending);
              break;
            default:
              order = compareColumn(a, b, columnName, sortAscending);
              break;
          }

          if (order !== 0) {
            // events a and b have different values for this column and can be sorted
            // break out of forEach early
            return false;
          }
        });

        return order;
      });
      this.storedResult = storedResult.toJS();
      return storedResult;
    }
  }, {
    key: 'onChangeFilter',
    value: function onChangeFilter(filter) {
      this.filter = filter;
    }
  }, {
    key: 'onToggleColumn',
    value: function onToggleColumn($index) {
      this.headers = this.headers.update($index, function (column) {
        return _extends({}, column, { visible: !column.visible });
      });
    }
  }, {
    key: 'onToggleStatisticsColumns',
    value: function onToggleStatisticsColumns() {
      var _this3 = this;

      this.showStatisticsColumns = !this.showStatisticsColumns;
      this.headers = this.headers.map(function (column) {
        if (column.isStatisticsColumn) {
          return _extends({}, column, { visible: _this3.showStatisticsColumns });
        } else {
          return column;
        }
      });
    }
  }, {
    key: 'canMerge',
    value: function canMerge() {
      return this.eventsToMerge.size === 2;
    }
  }, {
    key: 'onMerge',
    value: function onMerge() {
      var aEventIdx = this.eventsToMerge.get(0);
      var bEventIdx = this.eventsToMerge.get(1);

      var a = this.events.find(function (ev) {
        return ev.get('id') === aEventIdx;
      });
      var b = this.events.find(function (ev) {
        return ev.get('id') === bEventIdx;
      });

      var tpl = (0, _immutable.Map)().merge(a).merge(b).set('name', a.get('name') + '-' + b.get('name')).set('groupFeeId', a.get('groupFeeId') || b.get('groupFeeId')).delete('id');

      return this._.fEventEditor(null, this.feis.get('id'), null, tpl, {
        merge: { a: a, b: b },
        split: false
      });
    }
  }]);

  return FeisSyllabusController;
}();

exports.default = _angular2.default.module('ifeis.routes.feiseanna.one.admin.syllabus', ['ngMaterial', 'ui.router', 'dndLists', 'ifeis.immutables', 'ifeis.syllabi.store', 'ifeis.syllabi.actions', 'ifeis.syllabi.editor']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.syllabus', {
    url: '/syllabus',
    template: require('./tpl.html'),
    controller: FeisSyllabusController,
    controllerAs: 'syllabus',
    ncyBreadcrumb: {
      label: 'Syllabus',
      parent: 'feiseanna.one.admin.manager'
    }
  });
}).directive('eventCharts', function () {
  return {
    restrict: 'E',
    scope: {
      charts: '=',
      selectEvent: '&',
      addToChart: '&'
    },
    link: function link(scope, el) {
      var render = function render() {
        return _reactDom2.default.render(_react2.default.createElement(_chart.EventChartList, {
          charts: scope.charts,
          selectEvent: function selectEvent(event) {
            return scope.selectEvent({ event: event });
          },
          addToChart: function addToChart(chart) {
            return scope.addToChart({ chart: chart });
          }
        }), el[0]);
      };

      scope.$watch('charts', render);
    }
  };
}).directive('eventTable', function () {
  return {
    restrict: 'E',
    scope: {
      headers: '=',
      filter: '=',
      events: '=',
      filteredEvents: '&',
      orderBy: '=',
      eventsToMerge: '=',
      selectEvent: '&',
      toggleEventToMerge: '&'
    },
    link: function link(scope, el) {
      var render = function render() {
        return _reactDom2.default.render(_react2.default.createElement(_table.EventTable, {
          headers: scope.headers,
          events: scope.filteredEvents(),
          orderBy: scope.orderBy,
          eventsToMerge: scope.eventsToMerge,
          selectEvent: function selectEvent(event) {
            return scope.selectEvent({ event: event });
          },
          toggleEventToMerge: function toggleEventToMerge(eventId) {
            return scope.$apply(function () {
              return scope.toggleEventToMerge({ eventId: eventId });
            });
          }
        }), el[0]);
      };

      // Speeds up page load - avoids render being called multiple times
      scope.$watchGroup(['headers', 'filteredEvents', 'events', 'filter', 'orderBy', 'eventLevels', 'eventTypes', 'eventsToMerge'], render);
    }
  };
}).directive('filterDrawer', function () {
  return {
    restrict: 'E',
    scope: {
      filter: '@',
      headers: '=', // immutable List
      mergeSplitViewEnabled: '&',
      showStatisticsColumns: '&',
      orderBy: '=', // immutable List

      onToggleSideMenu: '&',
      onToggleColumn: '&',
      onChangeFilter: '&',
      onToggleMergeSplitView: '&',
      onToggleStatisticsColumns: '&',
      setOrderBy: '&'
    },
    template: _filterDrawer2.default,
    link: function link(scope) {
      // Prevent re-arranging items in available columns list
      scope.allowedTypes = ['order-by-type']; // for availableColumnsToSortBy list
      scope.orderByType = 'order-by-type'; // type of orderByMutable list items

      // highlight available lists to drag to
      scope.dragStart = function (event) {
        if (event.target.classList.contains('js-order-by-item')) {
          // dragging orderBy item, can re-arrange in orderBy or move down to available columns
          scope.highlightOrderBy = true;
          scope.highlightAvailableColumns = true;
        } else {
          // dragging availableColumn item, can only move to orderBy
          scope.highlightOrderBy = true;
        }
      };

      // remove highlight from all lists
      scope.dragEnd = function () {
        scope.highlightOrderBy = false;
        scope.highlightAvailableColumns = false;
      };

      // reorder table if user moved an order from orderBy list
      scope.removeOrderAtIndex = function (_ref) {
        var index = _ref.index;

        scope.orderByMutable.splice(index, 1);
        scope.setOrderBy({ orderBy: scope.orderByMutable });
      };

      scope.removeAvailableAtIndex = function (_ref2) {
        var index = _ref2.index;

        scope.availableColumnsToSortBy.splice(index, 1);
      };

      // Ascending/Descending icon toggle event handler
      scope.toggleSortDirection = function ($index) {
        scope.orderByMutable[$index].asc = !scope.orderByMutable[$index].asc;
        scope.setOrderBy({ orderBy: scope.orderByMutable });
      };

      // available columns are headers minus columns already used to sort by
      function getAvailableColumnsToSortBy(orderByMutable) {
        return _table.INITIAL_COLUMN_HEADERS.filter(function (col) {
          return !col.hideColumnName;
        }) // exclude certain columns (i.e. merge/split checkbox column)
        .map(function (col) {
          return col.name;
        }).toOrderedSet().subtract(orderByMutable.map(function (col) {
          return col.name;
        })) // remove items already in orderByMutable
        .map(function (columnName) {
          return { name: columnName, asc: true };
        }) // convert to orderBy format
        .toJS() // make mutable for drag/drop functionality
        ;
      }

      // update orderByMutable and availableColumnsToSortBy when orderBy is changed externally
      scope.$watch('orderBy', function (newOrderBy, oldOrderBy) {
        // only update when orderBy changed or orderByMutable is not yet set (first run)
        if (newOrderBy === oldOrderBy && scope.orderByMutable) {
          return;
        }

        scope.orderByMutable = scope.orderBy.toJS();
        scope.availableColumnsToSortBy = getAvailableColumnsToSortBy(scope.orderByMutable);
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/syllabus/index.js
// module id = 576
// module chunks = 0